import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppDeleteIcon } from 'shared/UI/UIKit/icons/Delete';
import { AppText } from 'shared/UI/UIKit/Text';
import type { BellSchedule } from 'services/api';
import { useBellScheduleDelete } from '../model';
import styles from './styles.module.scss';

interface BellScheduleDeleteProps {
  bellSchedule: BellSchedule;
  refreshTable: () => void;
}

export const BellScheduleDelete = ({ bellSchedule, refreshTable }: BellScheduleDeleteProps) => {
  const {
    state: { modalVisible },
    methods: { showModal, hideModal, onSubmit },
  } = useBellScheduleDelete({ bellSchedule, refreshTable });

  return (
    <>
      <AppDeleteIcon className={styles.icon} onClick={showModal} />

      <AppModal
        content={<AppText>Подтвердите удаление расписания {bellSchedule.name}</AppText>}
        title="Удалить расписание"
        visible={modalVisible}
        onCancel={hideModal}
        destroyOnClose
        footer={
          <AppFlex direction="row">
            <AppButton type="primary" onClick={onSubmit}>
              Удалить
            </AppButton>
            <AppButton type="outline" onClick={hideModal}>
              Закрыть
            </AppButton>
          </AppFlex>
        }
      />
    </>
  );
};
